import { defineMessages } from 'react-intl';

export default defineMessages({
  areYouClaimingForDamaged: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForDamaged',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },
  areYouClaimingForBaggageDelay: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },
  travelSupplierOrProviderInformation: {
    id: 'fastCover.stepPersonalItem.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.stepPersonalItem.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },
  origination: {
    id: 'fastCover.stepPersonalItem.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.stepPersonalItem.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.stepPersonalItem.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.stepPersonalItem.destination',
    defaultMessage: 'Destination',
  },
  sectionTitle: {
    id: 'fastCover.stepPersonalItem.sectionTitle',
    defaultMessage:
      'Section 4 - Damaged, Lost or Stolen Luggage, Travel Documents or Cash',
  },
  yes: {
    id: 'fastCover.stepPersonalItem.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepPersonalItem.no',
    defaultMessage: 'No',
  },
  areYouClaimingForLossTheftOrDamageTo: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForLossTheftOrDamageTo',
    defaultMessage: 'Are you claiming for Loss, Theft or Damage to:',
  },
  passportsCreditCards: {
    id: 'fastCover.stepPersonalItem.passportsCreditCards',
    defaultMessage: 'Passports, Credit Cards & Credit Card Fraud?',
  },
  theftOfCash: {
    id: 'fastCover.stepPersonalItem.theftOfCash',
    defaultMessage: 'Theft of Cash',
  },
  luggageAndPersonalEffects: {
    id: 'fastCover.stepPersonalItem.luggageAndPersonalEffects',
    defaultMessage: 'Luggage and Personal Items',
  },
  luggageInclude: {
    id: 'fastCover.stepPersonalItem.luggageInclude',
    defaultMessage:
      'Luggage includes your bags, clothes, devices and other personal belongings.',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepPersonalItem.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepPersonalItem.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepPersonalItem.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepPersonalItem.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepPersonalItem.document1',
    defaultMessage:
      'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.)',
  },
  document2: {
    id: 'fastCover.stepPersonalItem.document2',
    defaultMessage: 'Damage or Repair report',
  },
  document3: {
    id: 'fastCover.stepPersonalItem.document3',
    defaultMessage: 'Quote for repair or replacement',
  },
  document4: {
    id: 'fastCover.stepPersonalItem.document4',
    defaultMessage:
      'Purchase receipt or other Evidence of Ownership for each item claimed',
  },
  document5: {
    id: 'fastCover.stepPersonalItem.document5',
    defaultMessage:
      "For all losses or delays caused by your Transport Provider, a 'Property Irregularity Report' from the Transport Provider",
  },
  document6: {
    id: 'fastCover.stepPersonalItem.document6',
    defaultMessage:
      'Written evidence from the Transport Provider confirming the days and hours your luggage was delayed and the time that it was returned to you',
  },
  document7: {
    id: 'fastCover.stepPersonalItem.document7',
    defaultMessage: 'Receipts for essential clothing and toiletries purchased',
  },
  document8: {
    id: 'fastCover.stepPersonalItem.document8',
    defaultMessage:
      'For Cash claims, Bank or Credit Card statements or ATM or Currency Conversion receipts showing withdrawal of funds',
  },
  document9: {
    id: 'fastCover.stepPersonalItem.document9',
    defaultMessage:
      'For mobile phone claims please block the IMEI letter with your network provider',
  },
  provideExplanation: {
    id: 'fastCover.stepPersonalItem.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  luggageWasLostStolenOrDamaged: {
    id: 'fastCover.stepPersonalItem.luggageWasLostStolenOrDamaged',
    defaultMessage:
      'If your luggage was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepPersonalItem.howItHappened',
    defaultMessage: '1. How it happened',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepPersonalItem.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepPersonalItem.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepPersonalItem.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepPersonalItem.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepPersonalItem.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepPersonalItem.delay',
    defaultMessage: 'Delay',
  },
  police: {
    id: 'fastCover.stepPersonalItem.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepPersonalItem.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepPersonalItem.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepPersonalItem.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepPersonalItem.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepPersonalItem.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepPersonalItem.notReported',
    defaultMessage: 'Not Reported',
  },
  descriptionOfItem: {
    id: 'fastCover.stepPersonalItem.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepPersonalItem.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepPersonalItem.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepPersonalItem.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepPersonalItem.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepPersonalItem.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepPersonalItem.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepPersonalItem.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepPersonalItem.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepPersonalItem.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepPersonalItem.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepPersonalItem.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepPersonalItem.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepPersonalItem.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepPersonalItem.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepPersonalItem.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepPersonalItem.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepPersonalItem.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepPersonalItem.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepPersonalItem.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepPersonalItem.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepPersonalItem.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepPersonalItem.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepPersonalItem.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepPersonalItem.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepPersonalItem.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepPersonalItem.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepPersonalItem.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepPersonalItem.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepPersonalItem.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepPersonalItem.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepPersonalItem.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepPersonalItem.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepPersonalItem.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepPersonalItem.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepPersonalItem.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepPersonalItem.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepPersonalItem.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  otherInsuranceAuthorization: {
    id: 'fastCover.stepPersonalItem.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / AUTHORISATION:',
  },
  companyName: {
    id: 'fastCover.stepPersonalItem.companyName',
    defaultMessage: 'Company Name',
  },
  typeOfPolicy: {
    id: 'fastCover.stepPersonalItem.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  policy: {
    id: 'fastCover.stepPersonalItem.policy',
    defaultMessage: 'Policy',
  },
  lossInformation: {
    id: 'fastCover.stepPersonalItem.lossInformation',
    defaultMessage: 'Loss Information',
  },
  dateOfLoss: {
    id: 'fastCover.stepPersonalItem.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },
  pleaseDescribeWhatOccurred: {
    id: 'fastCover.stepPersonalItem.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred:',
  },
  placeOfLoss: {
    id: 'fastCover.stepPersonalItem.placeOfLoss',
    defaultMessage: 'Place of Loss:',
  },
  name: {
    id: 'fastCover.stepPersonalItem.name',
    defaultMessage: 'Name',
  },
  address: {
    id: 'fastCover.stepPersonalItem.address',
    defaultMessage: 'Address',
  },
  contact: {
    id: 'fastCover.stepPersonalItem.contactF',
    defaultMessage: 'Contact',
  },
  phone: {
    id: 'fastCover.stepPersonalItem.phone',
    defaultMessage: 'Phone',
  },
  delayInformation: {
    id: 'fastCover.stepPersonalItem.delayInformation',
    defaultMessage: 'Delay Information',
  },
  lossInformationWithIdx: {
    id: 'fastCover.stepPersonalItem.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.stepPersonalItem.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },
  howMuchReceivedReimbursement: {
    id: 'fastCover.stepPersonalItem.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },
  fromWhom: {
    id: 'fastCover.stepPersonalItem.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  delayInformationWithIdx: {
    id: 'fastCover.stepPersonalItem.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.stepPersonalItem.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  haveYouMadeAClaimWithYourTravelProvider: {
    id: 'fastCover.stepPersonalItem.haveYouMadeAClaimWithYourTravelProvider',
    defaultMessage: 'Have you made a claim with your Travel provider?',
  },
  itemDescription: {
    id: 'fastCover.stepPersonalItem.itemDescription',
    defaultMessage: 'Item Description',
  },
  estimatedValue: {
    id: 'fastCover.stepPersonalItem.estimatedValue',
    defaultMessage: 'Estimated Value',
  },
  scheduledDateOfReturn: {
    id: 'fastCover.stepPersonalItem.scheduledDateOfReturn',
    defaultMessage: 'Scheduled Date of Return',
  },
  scheduledDateOfDeparture: {
    id: 'fastCover.stepPersonalItem.scheduledDateOfDeparture',
    defaultMessage: 'Scheduled Date of Departure',
  },
  areYouClaimingForALostItem: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForALostItem',
    defaultMessage: 'Are you claiming for lost items?',
  },
  areYouClaimingForValuables: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForValuables',
    defaultMessage: 'Are you claiming for valuables?',
  },
  areYouClaimingForBaggageDelayPerDay: {
    id: 'fastCover.stepPersonalItem.areYouClaimingForBaggageDelayPerDay',
    defaultMessage: 'Are you claiming for Baggage Delay (Per Day)?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PersonalItemStep/messages.js